import React, { useState } from 'react';
import { ModalArea } from '../../common/ModalButtonArea';
import { Form } from 'react-bootstrap';
import { BigButton } from '../../common';
import {
  apiAddConfiguratorLink,
  apiUpdateProductConfiguratorLink,
  apiUpdateTextureConfiguratorLink,
} from '../../helpers/api';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { dispatcher } from '../../helpers/projectHelper';
import { setTriggerProductContentUpdate } from '../../redux/slicers/productV2Slicer';
import { updatePublicLinkProductTexture } from './ShareButtonV2/helpers';
import isURL from 'validator/lib/isURL';

function AddConfigurator({ show, setShow, data, _name, _link, isUpdate, setSelectedItem }) {
  const _configuratorName = _name || data?.info?.name || '';
  const [name, setName] = useState(_configuratorName);
  const [link, setLink] = useState(_link || '');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    if (!link) return;
    setLoading(true);
    event?.preventDefault();
    try {
      if (isUpdate) {
        const api = !data.product
          ? apiUpdateTextureConfiguratorLink
          : apiUpdateProductConfiguratorLink;
        const formData = new FormData();
        formData.append('name', name);
        formData.append('url', link);
        const response = await api(data?.product || data?.texture, data?.id, formData);
        if (response?.status) {
          successToast('Configurator updated successfully!');
          setSelectedItem?.(response?.data);
          dispatcher(setTriggerProductContentUpdate({ id: data?.product || data?.texture }));
          updatePublicLinkProductTexture({
            productId: data?.product || data?.texture,
            isTexture: Boolean(data?.texture),
          });
          setShow(false);
        } else if (response?.message) {
          errorToast(response?.message);
        }
      } else {
        const payload = {
          content_type_id: 321,
          is_pack: true,
          is_v2: true,
          name: name,
          url: link,
        };
        if (data?.product) {
          payload.product_id = data.product;
        } else payload.texture_id = data.texture;
        const response = await apiAddConfiguratorLink(payload);
        if (response?.status) {
          successToast('Configurator added successfully!');
          dispatcher(setTriggerProductContentUpdate({ id: data?.product || data?.texture }));
          // refetch?.()
          updatePublicLinkProductTexture({
            productId: data?.product || data?.texture,
            isTexture: Boolean(data?.texture),
          });
          setShow(false);
        } else if (response?.message) {
          errorToast(response?.message);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const isDisabled = () => {
    return (
      !link ||
      !name ||
      link?.trim() === '' ||
      name?.trim() === '' ||
      !isURL(link)
    );
  };

  return (
    <ModalArea
      showModal={show}
      setShowModal={setShow}
      title={`${isUpdate ? 'Update' : 'Add'} Configurator`}
      size="md"
      centered={true}
      body={
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formName" style={{ fontWeight: 'bold' }}>
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Name"
              value={name}
              required={true}
              style={{ borderRadius: '4px' }}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formLink" style={{ fontWeight: 'bold' }} className="mt-3">
            <Form.Label>Link</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Link"
              value={link}
              required={true}
              style={{ borderRadius: '4px' }}
              onChange={(e) => setLink(e.target.value)}
            />
          </Form.Group>
          <BigButton
            disabled={isDisabled()}
            isLoading={loading}
            variant="primary"
            className="bigButton lf-btn-1 btn-v2 mt-3 m-auto"
            type="submit">
            Submit
          </BigButton>
        </Form>
      }
    />
  );
}

export default AddConfigurator;
